// extracted by mini-css-extract-plugin
export default {"container":"Box_container__sqEVG","hasSiblings":"Box_hasSiblings__NXWbi","noSiblings":"Box_noSiblings__ILRnV"};